import React from 'react';

const VisitStatus = {
  pending: (
    <span className="bg-[#E5F6FF] rounded-full py-[2px] px-5 text-river-blue inline-flex items-center space-x-2 h-[33px]">
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.50008" cy="2.50008" r="2.33333" fill="#2FAEF3" />
      </svg>
      <span className="text-[13px] !leading-0 flex-shrink-0">New visit</span>
    </span>
  ),
  completed: (
    <span className="bg-[#DCFAEA] rounded-full py-[2px] px-5 text-[#2BCA76] text-xs inline-flex items-center space-x-2 h-[33px]">
      <svg
        width="18"
        height="10"
        viewBox="0 0 18 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.52146 5.49763L7.80841 8.60079L16.6528 0.162632C16.8878 -0.0616265 17.2602 -0.052875 17.4844 0.182179C17.7087 0.417234 17.6999 0.789581 17.4649 1.01384L8.2166 9.83737C7.99019 10.0534 7.63428 10.0543 7.40673 9.83949L3.71383 6.35309C3.4776 6.13007 3.4669 5.75778 3.68992 5.52155C3.91294 5.28532 4.28523 5.27461 4.52146 5.49763ZM0.184422 6.35309C-0.0518075 6.13007 -0.0625157 5.75778 0.160505 5.52155C0.383525 5.28532 0.755821 5.27461 0.992051 5.49763L4.68495 8.98403C4.92118 9.20705 4.93189 9.57935 4.70887 9.81558C4.48585 10.0518 4.11355 10.0625 3.87732 9.83949L0.184422 6.35309ZM8.50455 6.19533C8.26949 6.41959 7.89714 6.41084 7.67289 6.17579C7.44863 5.94073 7.45738 5.56839 7.69243 5.34413L13.1234 0.162632C13.3584 -0.0616265 13.7308 -0.052875 13.955 0.182179C14.1793 0.417234 14.1705 0.789581 13.9355 1.01384L8.50455 6.19533Z"
          fill="#2BCA76"
        />
      </svg>
      <span className="text-[13px] leading-0 flex-shrink-0">Complete</span>
    </span>
  ),
  requested: (
    <span className="bg-[#EBF2FC] rounded-full py-[2px] px-5 text-river-black text-xs inline-flex items-center space-x-2 h-[33px]">
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.50008" cy="2.50008" r="2.33333" fill="#303030" />
      </svg>
      <span className="text-[13px] leading-0 flex-shrink-0">Requested</span>
    </span>
  ),
  'sent-to-lab': (
    <span className="bg-[#E5F6FF] rounded-full py-[2px] px-5 text-river-blue inline-flex items-center space-x-2 h-[33px]">
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.50008" cy="2.50008" r="2.33333" fill="#2FAEF3" />
      </svg>
      <span className="text-[13px] !leading-0 flex-shrink-0">Sent To Lab</span>
    </span>
  ),
  'received-report': (
    <span className="bg-[#DCFAEA] rounded-full py-[2px] px-5 text-[#2BCA76] text-xs inline-flex items-center space-x-2 h-[33px]">
      <svg
        width="18"
        height="10"
        viewBox="0 0 18 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.52146 5.49763L7.80841 8.60079L16.6528 0.162632C16.8878 -0.0616265 17.2602 -0.052875 17.4844 0.182179C17.7087 0.417234 17.6999 0.789581 17.4649 1.01384L8.2166 9.83737C7.99019 10.0534 7.63428 10.0543 7.40673 9.83949L3.71383 6.35309C3.4776 6.13007 3.4669 5.75778 3.68992 5.52155C3.91294 5.28532 4.28523 5.27461 4.52146 5.49763ZM0.184422 6.35309C-0.0518075 6.13007 -0.0625157 5.75778 0.160505 5.52155C0.383525 5.28532 0.755821 5.27461 0.992051 5.49763L4.68495 8.98403C4.92118 9.20705 4.93189 9.57935 4.70887 9.81558C4.48585 10.0518 4.11355 10.0625 3.87732 9.83949L0.184422 6.35309ZM8.50455 6.19533C8.26949 6.41959 7.89714 6.41084 7.67289 6.17579C7.44863 5.94073 7.45738 5.56839 7.69243 5.34413L13.1234 0.162632C13.3584 -0.0616265 13.7308 -0.052875 13.955 0.182179C14.1793 0.417234 14.1705 0.789581 13.9355 1.01384L8.50455 6.19533Z"
          fill="#2BCA76"
        />
      </svg>
      <span className="text-[13px] leading-0 flex-shrink-0">Results ready</span>
    </span>
  ),
  none: (
    <span className="bg-[#EBF2FC] rounded-full py-[2px] px-5 text-river-black text-xs inline-flex items-center space-x-2 h-[33px]">
      <span className="text-[13px] leading-0 flex-shrink-0">No Recent Visit</span>
    </span>
  ),
};

export default VisitStatus;
